import React from 'react'
import { Hammer } from 'lucide-react'
import Brand from './Brand'
import Unit from './Unit'
import { HeadingWithIcon } from '../../../../Components/Utils/Settingheading'
import Equip from './equip'
import Category from './Category'
import Type from './type'

const IndexEquipment = () => {
  return (
    <div>
      
             <HeadingWithIcon icon={Hammer} title="Equipment" />

    <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
   
    
     <div className=' w-full md:w-1/2 lg:w-1/3 '>
        <Unit/>
     </div> 
     
     <div className=' w-full md:w-1/2 lg:w-1/3 '>
        <Type/>
     </div>  
   
     </div>
        <Category/>
     
     </div>
  )
}

export default IndexEquipment